// Swatch rendering — ports viz/app.py's _render_legend_tab HTML (there built
// with st.markdown(unsafe_allow_html=True); here built as real DOM nodes).
import type { Legend, RGB } from "./types";

function rgb(c: RGB): string {
  return `rgb(${c[0]}, ${c[1]}, ${c[2]})`;
}

export function renderLegend(container: HTMLElement, legend: Legend | null): void {
  container.innerHTML = "";
  if (!legend) {
    container.append(el("p", { className: "caption" }, "No dataset loaded."));
    return;
  }

  if (legend.type === "continuous") {
    const bar = el("div", { className: "legend-swatch-bar" });
    for (const stop of legend.stops) {
      const seg = el("div");
      seg.style.background = rgb(stop);
      bar.append(seg);
    }
    container.append(bar);
    container.append(
      el(
        "p",
        { className: "caption" },
        `${legend.min.toPrecision(3)}  →  ${legend.max.toPrecision(3)}  (2nd–98th percentile)`,
      ),
    );
  } else if (legend.type === "discrete") {
    for (const [label, color] of Object.entries(legend.palette)) {
      const row = el("div", { className: "legend-row" });
      const swatch = el("span", { className: "legend-swatch" });
      swatch.style.background = rgb(color);
      row.append(swatch, document.createTextNode(label));
      container.append(row);
    }
  } else {
    container.append(
      el("p", { className: "caption" }, legend.note ?? legend.error ?? "Column not colourable."),
    );
  }
}

// Tiny DOM-builder helper — avoids repeating createElement/className/append
// boilerplate everywhere without pulling in a templating library.
function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  props: Partial<HTMLElementTagNameMap[K]> = {},
  text?: string,
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  Object.assign(node, props);
  if (text !== undefined) node.textContent = text;
  return node;
}

export { el };
